import $ from "jquery";

export default class Request {
    constructor() { }

    private cookie(name: string) {
        const key = `${name}=`;
        for (const item of document.cookie.split(';')) {
            const value = item.trim();
            if (value.indexOf(key) === 0) {
                return value.substring(key.length);
            }
        }
        return '';
    }

    public async post(url: string, data: any = {}) {
        let request = () => {
            return new Promise((resolve) => {
                const csrf = this.cookie('KIERA_CSRF');
                $.ajax({
                    url: url,
                    type: "POST",
                    data: data,
                    headers: csrf ? { "X-KiERA-CSRF": csrf } : {}
                }).always(function (res) {
                    resolve(res);
                });
            });
        }

        return await request();
    }

}